<template>
  <form @submit.prevent="handleSubmit">
    <modal-card title="edit Promo Group" style="margin: 0 auto;" contains-dropdown>
      <div class="columns">
        <div class="column is-8">
          <b-field label="Name">
            <b-input type="text" @blur="getSLug" v-model="form.name"></b-input>
          </b-field>

          <b-field label="Key">
            <b-input type="text" v-model="form.key" readonly></b-input>
          </b-field>

          <b-field label="Expire Date">
            <datetimepicker v-model="form.expired_at"></datetimepicker>
          </b-field>

          <b-field label="Description">
            <b-input type="textarea" v-model="form.description"></b-input>
          </b-field>

          <b-field label="Redemption Message">
            <b-input type="textarea" v-model="form.redemption_message"></b-input>
          </b-field>

        </div>
        <div class="column is-4">
          <div class="box">
            <b-field label="Logo" class="level">
              <upload-file
                class="level-right"
                ref="uploadLogoFile"
                :endpoint="kytebaseMediaUploadUrl"
                :additional="{ collection: 'images' }"
                @uploaded="onLogoUploaded"
                auto-reset
              >
                <template slot-scope="{progress}">
                  <div
                    v-if="progress && ! progress.isComplete()"
                  >Uploading {{ progress.percent() }}%</div>

                  <image-picker
                    v-else
                    @picked="file => $refs.uploadLogoFile.upload(file)"
                    croppable
                    :croppie="{ viewMode: 1 }"
                  >
                    <a slot="trigger">Upload</a>
                  </image-picker>
                </template>
              </upload-file>
            </b-field>

            <div class="has-text-centered">
              <img v-if="logo_image_url" :src="logo_image_url" style="width: 80%;" />
            </div>
          </div>

          <div class="box">
            <b-field label="Background" class="level">
              <upload-file
                class="level-right"
                ref="uploadBgFile"
                :endpoint="kytebaseMediaUploadUrl"
                :additional="{ collection: 'images' }"
                @uploaded="onBackgroundUploaded"
                auto-reset
              >
                <template slot-scope="{progress}">
                  <div
                    v-if="progress && ! progress.isComplete()"
                  >Uploading {{ progress.percent() }}%</div>

                  <image-picker
                    v-else
                    @picked="file => $refs.uploadBgFile.upload(file)"
                    croppable
                    :croppie="{ viewMode: 1 }"
                  >
                    <a slot="trigger">Upload</a>
                  </image-picker>
                </template>
              </upload-file>
            </b-field>

            <div class="has-text-centered">
              <img v-if="background_image_url" :src="background_image_url" style="width: 98%;" />
            </div>
          </div>
        </div>
      </div>



      <div slot="foot">
        <button type="button" class="button" @click="$parent.close()">
          Close
        </button>

        <button
          class="button is-primary"
          :class="{ 'is-loading': form.processing }"
        >
          Edit Promo Group
        </button>
      </div>
    </modal-card>
  </form>
</template>

<script>
import ImagePicker from "@/components/ImagePicker";
import UploadFile from "@/components/UploadFile";

export default {
  components: {
    ImagePicker,
    UploadFile,
  },
  props: {
    promotion:{
      type: Object,
      required: true
    },
  },
  data() {
    return {
      logo_image_url: this.promotion.logo_image_url,
      background_image_url: this.promotion.background_image_url,
      form: new window.Form({
        name: this.promotion.name,
        key: this.promotion.key,
        expired_at: this.promotion.expired_at,
        redemption_message: this.promotion.redemption_message,
        description: this.promotion.description,
        logo_path: this.promotion.logo_path,
        background_path: this.promotion.background_path,
      })
    };
  },
  computed: {
    kytebaseMediaUploadUrl() {
      return window.app.$store.getters.kytebaseMediaUploadUrl;
    }
  },
  methods: {
    handleSubmit() {
      this.form.put(`/admin/api/promo/group/edit/${this.promotion.id}`).then(this.whenEdited);
    },

    getSLug() {
      this.form.key = this.form.name.replace(/\s+/g, '-').toLowerCase();
    },

    onLogoUploaded({ data: image }) {
      this.form.logo_path = image.path;
      this.logo_image_url = image.url;
    },

    onBackgroundUploaded({ data: image }) {
      this.form.background_path = image.path;
      this.background_image_url = image.url;
    },

    whenEdited() {
      this.$buefy.toast.open("Group Updated.");
      this.$parent.close();
      window.location.reload();
    }
  }
};
</script>
